import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { DemoCleanupService } from './demo-cleanup.service';

@Module({
  imports: [],
  providers: [DemoCleanupService, PrismaService],
})
export class DemoCleanupModule {}
